/**
 * @generated SignedSource<<2ae8d27e91e9ba3ab8a97e91ffce828e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceSignalReceiversQuery$variables = {
  workspaceId: string;
  workspaceSignalId: string;
};
export type WorkspaceSignalReceiversQuery$data = {
  readonly workspace: {
    readonly signal: {
      readonly id: string;
      readonly potentialReceiverStores: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorListItem_receiverStore" | "ReceiverStoresSelector_receiverStores">;
      }>;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly status: WorkspaceSignalStatus;
      readonly topic: {
        readonly id: string;
        readonly isPrivate: boolean;
      } | null;
      readonly updatedAtDate: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
    readonly topics: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"TopicSelector_orgTopic">;
    }> | null;
  };
};
export type WorkspaceSignalReceiversQuery = {
  response: WorkspaceSignalReceiversQuery$data;
  variables: WorkspaceSignalReceiversQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceSignalId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceSignalId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgTopic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "updatedBy",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalReceiversQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v2/*: any*/),
          "concreteType": "Workspace",
          "kind": "LinkedField",
          "name": "workspace",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgTopic",
              "kind": "LinkedField",
              "name": "topics",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TopicSelector_orgTopic"
                }
              ],
              "storageKey": null
            },
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "SignalWorkspace",
                "kind": "LinkedField",
                "name": "signal",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnzonedDate",
                    "kind": "LinkedField",
                    "name": "updatedAtDate",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "FormattedDate"
                      }
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReceiverStore",
                    "kind": "LinkedField",
                    "name": "potentialReceiverStores",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ReceiverStoresSelector_receiverStores"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ReceiverStoresSelectorListItem_receiverStore"
                      }
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceSignalReceiversQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v10/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "signal",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includeExternalId",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "workspaceBreadcrumbs",
                        "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "routedTeams",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "423616ed5bc582f28a8a491f189a4e92",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalReceiversQuery",
    "operationKind": "query",
    "text": "query WorkspaceSignalReceiversQuery(\n  $workspaceSignalId: ID!\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    topics {\n      ...TopicSelector_orgTopic\n      id\n    }\n    signal(id: $workspaceSignalId) {\n      id\n      status\n      updatedAtDate {\n        isoString\n        ...FormattedDate\n      }\n      topic {\n        id\n        isPrivate\n      }\n      receiverStores {\n        id\n      }\n      potentialReceiverStores {\n        ...ReceiverStoresSelector_receiverStores\n        ...ReceiverStoresSelectorListItem_receiverStore\n        id\n      }\n      updatedBy {\n        name\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store on Store {\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n\nfragment ReceiverStoresSelectorListItem_receiverStore on ReceiverStore {\n  store {\n    ...ReceiverStoresSelectorMain_receiverStore\n    id\n  }\n  routedTeams {\n    ...ReceiverStoresSelectorTeamsIndicator_teams\n    id\n  }\n}\n\nfragment ReceiverStoresSelectorMain_receiverStore on Store {\n  id\n  name\n  ...OrgStoreWorkspaceBreadcrumbs_store\n}\n\nfragment ReceiverStoresSelectorTeamsIndicator_teams on Team {\n  id\n  name\n  ...AHTeamIconCircle\n}\n\nfragment ReceiverStoresSelector_receiverStores on ReceiverStore {\n  store {\n    id\n    name\n    workspaceBreadcrumbs(includeExternalId: true)\n  }\n  ...ReceiverStoresSelectorListItem_receiverStore\n}\n\nfragment TopicSelector_orgTopic on OrgTopic {\n  id\n  name\n  isPrivate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "a67f9643d03adcd51f1f330a6e305c29";

export default node;
